/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
import { FaChevronCircleRight } from '@react-icons/all-files/fa/FaChevronCircleRight';

import keygen from 'gatsby-core-theme/src/helpers/keygen';
import Button from 'gatsby-core-theme/src/components/atoms/button';

import styles from './sport-buttons.module.scss';

const SportButtons = ({
  sports,
  prefix = '',
  icon = <FaChevronCircleRight />,
  isHeader = true,
  gtmClass = '',
}) => (
  <div className={`${styles.sportButtons} ${isHeader && styles.header}`}>
    <ul>
      {sports &&
        sports.map((sport) => (
          <React.Fragment key={keygen()}>
            {sport.path && (
              <li key={keygen()}>
                <Button
                  to={sport.path}
                  className={sport.name}
                  isInternalLink
                  btnText={
                    <>
                      {icon && icon}
                      {`${prefix} ${sport.path}`}
                    </>
                  }
                  gtmClass={`${gtmClass} sports-btn-gtm btn-cta`}
                />
              </li>
            )}
          </React.Fragment>
        ))}
    </ul>
  </div>
);

SportButtons.propTypes = {
  sports: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      path: PropTypes.string,
    })
  ).isRequired,
  prefix: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.any]),
  isHeader: PropTypes.bool,
  gtmClass: PropTypes.string,
};

export default SportButtons;
